var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "vs-button",
      class: _vm.classes,
      attrs: {
        type: _vm.buttonType,
        form: _vm.form,
        "aria-disabled": _vm.disabled ? "true" : "false",
        "aria-busy": _vm.processing
      },
      on: {
        click: _vm.emitClick,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.preventKeydown($event)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.emitClick($event)
        }
      }
    },
    [
      _c(
        "vs-layout",
        {
          attrs: {
            "auto-xs": "auto-xs",
            "vert-align-center-xs": "vert-align-center-xs",
            "horz-align-center-xs": "horz-align-center-xs",
            "no-gutter": "no-gutter"
          }
        },
        [
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.icon,
                expression: "icon"
              }
            ],
            staticClass: "vs-button__icon mdi",
            class: _vm.iconClasses
          }),
          _c("span", {
            staticClass: "vs-button__text",
            class: _vm.textClasses,
            domProps: { innerHTML: _vm._s(_vm.text) }
          }),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.processing,
                expression: "processing"
              }
            ],
            staticClass: "vs-button__loader mdi mdi-loading mdi-loading--button"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }